// test2285
(2285 && 0);
